import Vue from 'vue'
import Store from 'store'

import RelatedProductCourse from './RelatedProductCourse.vue'

const el = '.nti-component--related-product-course'
const DOM = document.querySelector(el)

const render = function(){
    if(DOM){
        new Vue({
            store: Store,
            el,
            components:{
                RelatedProductCourse
            },
            template: '<RelatedProductCourse />'
        })
    }
}

export default {
    render
}